import React from 'react';
import styles from '../css/PatientDeclaration.module.css';

export default function PatientDeclaration({
  totals = { amount: 'R129.18', vat: 'R19.38', total: 'R148.56' },
  patientSignature = null,
}) {
  return (
    <section className={styles.card}>
      <div className={styles.grid}>
        {/* Left column */}
        <div className={styles.leftCol}>
          <p className={styles.boldLine}>
            I, the member, certify that I am liable for the above amount until final settlement by the medical aid, and that settlement by the medical aid will discharge me from liability.
          </p>
          <div className={styles.smallNotes}>
            <div>The member remains liable for any charges not paid by the medical aid.</div>
            <div>The medicine was supplied in good faith.</div>
            <div>Keep medicine in original packaging.</div>
          </div>
        </div>

        {/* Right column */}
        <div className={styles.rightCol}>
          <p className={styles.boldLine}>I have received the medicine referred to in this prescription and am aware of its use.</p>
          <div className={styles.sigTotalsRow}>
            <div className={styles.signatureBlock}>
              {patientSignature ? (
                <img className={styles.sigImage} src={patientSignature} alt="Member/Patient signature" />
              ) : (
                <div className={styles.sigPlaceholder} />
              )}
              <div className={styles.sigCaption}>Member/Patient</div>
            </div>
            <div className={styles.totalsRight}>
              {/* <div><span className={styles.label}>R129.18</span></div> */}
              {/* <div><span className={styles.label}>+VAT:</span> <span className={styles.value}>{totals.vat}</span></div> */}
              <div><span className={styles.label}>Total excl. VAT:</span> <span className={styles.value}>{totals.total}</span></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

